module.exports = __webpack_public_path__ + "static/semantic-image-bordered-1397f156ff2eecf988dbc7e3a99ac850.png";